var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchAgency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66659 6.33333H11.8666C12.6133 6.33333 12.9867 6.33333 13.2719 6.47866C13.5228 6.60649 13.7268 6.81046 13.8546 7.06135C13.9999 7.34656 13.9999 7.71993 13.9999 8.46667V13M8.66659 13V3.13333C8.66659 2.3866 8.66659 2.01323 8.52126 1.72801C8.39343 1.47713 8.18946 1.27316 7.93857 1.14532C7.65336 1 7.27999 1 6.53325 1H4.13325C3.38652 1 3.01315 1 2.72793 1.14532C2.47705 1.27316 2.27307 1.47713 2.14524 1.72801C1.99992 2.01323 1.99992 2.3866 1.99992 3.13333V13M14.6666 13H1.33325M4.33325 3.66667H6.33325M4.33325 6.33333H6.33325M4.33325 9H6.33325",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAgency);
export default __webpack_public_path__ + "static/media/switchAgency.1a186cd10c4242f295f135e416ab73c2.svg";
export { ForwardRef as ReactComponent };